export function showError({ field, message }) {
  field.classList.add("is-error");

  const error = document.createElement("div");
  error.className = "form-error";
  error.textContent = message;

  // если чекбокс или radio
  if (field.closest(".contacts__agree")) {
    field.closest(".contacts__agree").append(error);
  } else if (field.closest(".contacts__radio-block")) {
    field.closest(".contacts__radio-block").append(error);
  } else {
    field.parentElement.append(error);
  }
}

export function clearErrors() {
  document.querySelectorAll(".form-error").forEach((el) => el.remove());
  document
    .querySelectorAll(".is-error")
    .forEach((el) => el.classList.remove("is-error"));
}
